import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-schedule-generate',
  templateUrl: './schedule-generate.component.html',
  styleUrls: ['./schedule-generate.component.css']
})
export class ScheduleGenerateComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/chitfund/schedule-generate/schedule-generate.component.ts